import React, { useEffect, useRef, useState } from "react";

export function TextInput({
    value,
    onChange,
    placeholder,
    maxLength = 2000,
    onSubmit,
}) {
    const [local, setLocal] = useState(value ?? "");
    const timeoutRef = useRef(null);
    const ref = useRef(null);

    useEffect(() => {
        setLocal(value ?? "");
    }, [value]);

    // debounce upstream update 300ms
    function handleChange(e) {
        const next = e.target.value.slice(0, maxLength);
        setLocal(next);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => onChange(next), 300);
    }

    function handleKeyDown(e) {
        if ((e.metaKey || e.ctrlKey) && e.key === "Enter") {
            e.preventDefault();
            // flush value before advancing
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            onChange(local);
            onSubmit?.();
        }
    }

    useEffect(() => {
        ref.current?.focus();
    }, []);

    return (
        <div data-testid="text-input">
            <textarea
                ref={ref}
                value={local}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                placeholder={placeholder}
                maxLength={maxLength}
                rows={6}
                aria-label="Your answer"
                className="w-full p-5 rounded-2xl border border-klareet-bor bg-klareet-card text-klareet-TEXT placeholder:text-klareet-DIM resize-y focus:border-klareet-T focus:ring-2 focus:ring-klareet-T/40 outline-none transition-colors duration-200"
            />
            <div className="mt-2 flex items-center justify-between text-xs text-klareet-MUT font-mono">
                <span>Optional · press ⌘/Ctrl + Enter to continue</span>
                <span
                    className={
                        local.length > maxLength * 0.9
                            ? "text-klareet-AMBER"
                            : undefined
                    }
                >
                    {local.length} / {maxLength}
                </span>
            </div>
        </div>
    );
}
